import React from "react";
import { useLocation, Link } from "react-router-dom";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Typography from "@mui/material/Typography";
import { capitalize } from "@mui/material/utils";
import { getUsers } from "../../utils/getUser";

// Mock user role for demonstration purposes
const userRole = getUsers()?.role; // This should be dynamically determined in your actual application

const pathTitles = {
  testing: "Components",
  "admin-dashboard": "Dashboard",
  "manager-dashboard": "Dashboard",
  "user-dashboard": "Dashboard",
  "open-orders": "Open Orders",
  sell: "Sell",
  profile: "Profile",
  quotes: "Quotes",
  "member-prequoted-cooks": "Sell",
  "prequoted-cooks": "Sell Catalog",
  "sell-catalog": "Sell Catalog",
  "member-instore-flips": "In-Store Flips",
  "member-payouts": "Payouts",
  "instore-flips": "In-Store Flips",
  "shipping-tracking": "Shipping & Tracking",
  payouts: "Payouts",
  "help-support": "Help & Support",
  "t&c": "Terms & Conditions",
};

const BreadcrumbComponent = () => {
  const location = useLocation();

  const pathSegments = location.pathname
    .split("/")
    .filter((segment) => segment);

  const breadcrumbItems = pathSegments.map((segment, index) => {
    const pathToSegment = `/${pathSegments.slice(0, index + 1).join("/")}`;
    let title = pathTitles[segment] || capitalize(segment.replace(/-/g, " "));

    if (index === pathSegments.length - 1) {
      // Last segment - display as text
      return (
        <Typography key={pathToSegment} color="textPrimary">
          {title}
        </Typography>
      );
    }

    const pathBasedOnRole =
      userRole === "SUPERADMIN"
        ? `/admin-dashboard`
        : userRole === "MANAGER"
          ? `/manager-dashboard`
          : userRole === "MEMBER" && `/user-dashboard`;
    // Non-last segment - display as link
    return (
      <Link
        key={pathToSegment}
        to={title === "Dashboard" ? pathBasedOnRole : pathToSegment}
        style={{ textDecoration: "none", color: "inherit" }}
      >
        {title}
      </Link>
    );
  });

  return <Breadcrumbs aria-label="breadcrumb">{breadcrumbItems}</Breadcrumbs>;
};

export default BreadcrumbComponent;
